module.exports = __webpack_public_path__ + "img/拼图测试.192a23ce.jpeg";